import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"
import { postFakeForgetPwd } from "../../../helpers/fakebackend_helper";

export const userForgetPassword = (user) => async (dispatch) => {
  try {
    const data = await postFakeForgetPwd({ email: user.email });
    if (data && data.success) {
      dispatch(userForgetPasswordSuccess(
        data.message || "If that email is registered, a reset link has been sent. Check your inbox."
      ));
    } else {
      dispatch(userForgetPasswordError((data && data.message) || "Something went wrong. Try again."));
    }
  } catch (forgetError) {
    dispatch(userForgetPasswordError(
      typeof forgetError === "string" ? forgetError : (forgetError && forgetError.message) || "Network error."
    ));
  }
}